Array.prototype.remove = function(val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};

const util = {
  // data() {
  //   return {
  //   }
  // },
  // created() {
  // },
  methods: {
    empty: function(objOrList) {
      return (
        objOrList == null ||
        objOrList.length === 0 ||
        typeof objOrList === "undefined"
      );
    },
    noEmpty: function(objOrList) {
      return !empty(objOrList);
    },
    // js默认用||即可   多个入参取第一个不为空的    let userType = or(user.userType,'Default')
    /*  or: function() {
                for (const argu of arguments) {
                  if (!empty(argu)) {
                    return argu
                  }
                }
              }*/
    objEqual: function(a, b) {
      if (!a && !b) {
        return true;
      }
      if (a && b) {
        var aProps = Object.getOwnPropertyNames(a);
        var bProps = Object.getOwnPropertyNames(b);
        aProps.remove("__ob__"); //可能是vue生成的属性
        bProps.remove("__ob__"); //可能是vue生成的属性
        if (aProps.length !== bProps.length) {
          return false;
        }
        for (var i = 0; i < aProps.length; i++) {
          var propName = aProps[i];
          if (a[propName] !== b[propName]) {
            return false;
          }
        }
        return true;
      }
      return false;
    },
    noNullAppend(appendBefore, param, appendAfter) {
      return param ? appendBefore + param + appendAfter : "";
    }
    // /**
    //  * 动态加载组件
    //  */
    // load: async function(componentPath) {
    //   // 若不可加载返回null, 若可加载,返回 () => import(`@/views${componentPath}`)
    //   return await loadEnsure(componentPath) ? () => import(`@/views${componentPath}`) : null
    // },
    // async loadEnsure(componentPath) {
    //   try {
    //     await import(`@/views${componentPath}`)
    //     return true
    //   } catch (e) {
    //     console.error(`${componentPath}组件加载异常.`, e)
    //     return false
    //   }
    // },
  }
};
/**
 * 超级常用的工具类
 */
export default util;
export const empty = util.methods.empty;
export const noEmpty = util.methods.noEmpty;
export const objEqual = util.methods.objEqual;
// export const load = util.methods.load
// export const loadEnsure = util.methods.loadEnsure

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}
